const MAX_TOTAL_PASSENGERS_AMOUNT = 9;

const DEFAULT_PASSENGERS_STATE = {
  adt: 1,
  chd: 0,
  inf: 0,
  yth: 1,
};

const PASSENGERS_CONSTRAINTS = {
  adt: {
    min: 1,
    max: 9,
  },
  chd: {
    min: 0,
    max: 8,
  },
  inf: {
    min: 0,
    max: 5,
  },
  yth: {
    min: 1,
    max: 9,
  },
};

export const passengersCounterConfig = {
  DEFAULT_PASSENGERS_STATE,
  PASSENGERS_CONSTRAINTS,
  MAX_TOTAL_PASSENGERS_AMOUNT,
};
